export class OptionItem {
    constructor(public id: number, public desc: string, public group?: number) { }
}
